export default "__VITE_ASSET__9e5bad5d__"